import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { NavRoutingLinkModule, RouteCategory, CountConfig} from './nav-routing.module';
import { timer, Observable } from 'rxjs';
import { ApiService } from 'src/app/handlers/apiHandler.service';
import { HttpResponse } from '@angular/common/http';
import { LoggerService } from 'src/app/handlers/logger.service';
import { environment } from 'src/environments/environment.dev';
import { Environment } from 'src/environments/environment';
import { takeWhile } from 'rxjs/operators';
import { OcrChannel } from 'src/app/constants/constants';
import { SharedService } from 'src/app/shared/shared.service';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-main',
  standalone: false,
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
})
export class NavComponent implements OnInit, OnDestroy {
  currentApplicationVersion = environment.appVersion;

  svgUrl = 'keyboard_arrow_left';
  fillColor = 'black';
  strokeColor = 'black';
  navIsToggled = false;
  navIsHovered = false;

  minimum = 20;
  maximum = 600;
  navSize = 280;

  navWidth: number = this.navSize;
  contentWidth: number = this.navSize;
  oldX = 0;
  grabber = false;
  dragging = false;

  navCategories: RouteCategory[] = NavRoutingLinkModule.links;

  countTimer: Observable<number>;
  alive = true;

  channels: any[];
  selectedChannel: number;
  selectedChannelId: number;

  constructor(
    private apiHandler: ApiService,
    private authService: AuthService,
    private router: Router,
    private logger: LoggerService,
    private sharedService: SharedService
  ) {}

  ngOnInit() {
    this.channels = [
      { name: 'Web UI', id: OcrChannel.WEB_UI },
      { name: 'Web UI Admin', id: OcrChannel.WEB_UI_ADMIN }
    ];

    // Set default selected channel - use the ID directly for Material Select
    this.selectedChannel = this.channels[0].id;
    this.selectedChannelId = this.channels[0].id;
    this.sharedService.setChannel(this.selectedChannelId);
    this.sharedService.sharedChannel.subscribe(channel => this.selectedChannelId = channel);
    this.ConfigureBadgeTimer();
  }

  ConfigureBadgeTimer() {
    let timeForCount = 2 * 60 * 1000;
    if (environment.status == Environment.Prod) {
      timeForCount = 15 * 1000;
    }
    this.countTimer = timer(0, timeForCount);
    this.countTimer.pipe(takeWhile(() => this.alive)).subscribe(() => {
      this.ConfigureBadges();
    });
  }

  ConfigureBadges() {
    this.logger.info('Start configuration for badges');

    // Check if selectedChannelId is defined
    if (this.selectedChannelId === undefined) {
      this.logger.error('Channel ID is undefined, using default value 5');
      this.selectedChannelId = 5; // Default to WEB_UI
    }

    this.navCategories.forEach(category => {
      if (category.countConfig !== undefined) {
        this.logger.info(`Start api call for badges ${category.name} : ${category.countConfig.url}?channelId=${this.selectedChannelId}`);
        this.apiHandler.getABCisRequest<CountConfig[]>(category.countConfig.api, `${category.countConfig.url}?channelId=${this.selectedChannelId}`).then((response: HttpResponse<CountConfig[]>) => {
          // Sets every counts to null
          this.logger.info(`Restart counts for ${category.name}`);
          category.link.forEach(primaryLink => {
            if (primaryLink.count !== undefined) {
              primaryLink.count.pendingCount = null;
            }
            if (primaryLink.links !== undefined) {
              primaryLink.links.forEach(secondaryLink => {
                if (secondaryLink.count !== undefined) {
                  secondaryLink.count.pendingCount = null;
                }
              });
            }
          });
          this.logger.info(`Set counts for ${category.name} with ${response.body}`);
          // Sets the counts of each link
          const countConfig: CountConfig[] = response.body;
          category.link.forEach(primaryLink => {
            if (primaryLink.count !== undefined) {
              countConfig.forEach(config => {
                if (config.jobId == primaryLink.count.jobId)
                  primaryLink.count.pendingCount = config.pendingCount;
              });
            }
            if (primaryLink.links !== undefined) {
              primaryLink.links.forEach(secondaryLink => {
                if (secondaryLink.count !== undefined) {
                  countConfig.forEach(config => {
                    if (config.jobId == secondaryLink.count.jobId)
                      secondaryLink.count.pendingCount = config.pendingCount;
                  });
                }
              });
            }
          });
        });
      }
    });
  }

  getSelectedChannelName(): string {
    const selected = this.channels.find(c => c.id === this.selectedChannel);
    return selected ? selected.name : '';
  }

  selectChannel(channelId: number): void {
    this.selectedChannel = channelId;
    this.selectedChannelId = channelId;
    this.sharedService.setChannel(this.selectedChannelId);
    this.ConfigureBadgeTimer();
  }

  // Updated to work with MatSelectChange
  onOptionSelected(event: MatSelectChange) {
    this.selectedChannelId = event.value;
    console.log('Selected channel ID:', this.selectedChannelId);
    this.sharedService.setChannel(this.selectedChannelId);
    this.ConfigureBadgeTimer();
  }

  ToggleNav() {
    if (!this.navIsToggled) {
      this.navWidth = this.minimum;
      this.contentWidth = this.minimum;
      this.svgUrl = 'menu';
    } else {
      this.navWidth = this.navSize;
      this.contentWidth = this.navSize;
      this.svgUrl = 'keyboard_arrow_left';
    }
    this.navIsToggled = !this.navIsToggled;
  }

  mouseEnterNav() {
    if (this.navIsToggled) {
      this.navWidth = this.navSize;
      this.navIsHovered = true;
      this.svgUrl = 'keyboard_arrow_right';
    }
  }

  mouseLeaveNav() {
    if (this.navIsHovered == true && this.navIsToggled) {
      this.navWidth = this.minimum;
      this.navIsHovered = false;
      this.svgUrl = 'menu';
    }
  }

  onMouseMove(event: MouseEvent) {
    if (!this.grabber) {
      return;
    }
    this.resizer(event.clientX - this.oldX);
    if (this.navWidth > this.minimum && this.navWidth < this.maximum)
      this.oldX = event.clientX;
  }

  onMouseUp(event: MouseEvent) {
    this.dragging = false;
    this.grabber = false;
    if (this.navWidth > this.minimum && this.navWidth < this.navSize) {
      if (this.navWidth < (this.navSize / 2)) {
        this.navWidth = this.minimum;
        this.navIsToggled = true;
        this.contentWidth = this.navWidth;
      } else {
        this.navWidth = this.navSize;
        this.contentWidth = this.navSize;
      }
    }
  }

  resizer(offsetX: number) {
    this.navWidth += offsetX;
    if (this.navWidth <= this.minimum) {
      this.navWidth = this.minimum;
      this.navIsToggled = true;
    }
    if (this.navWidth > this.maximum) this.navWidth = this.maximum;
    this.contentWidth = this.navWidth;
  }

  onMouseDown(event: MouseEvent) {
    if (!this.navIsToggled) {
      this.dragging = true;
      this.grabber = true;
      this.oldX = event.clientX;
      event.preventDefault();
    }
  }

  logOut() {
    this.authService.logout();
    this.router.navigateByUrl('/Login');
  }

  ngOnDestroy() {
    this.alive = false;
  }
}
